var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"faq"},[_c('div',{staticClass:"contentsTitle colorGrey2"},[_vm._v("FAQ")]),_c('Accordion',{attrs:{"list":_vm.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }